<template>
  <div>
    <div class="title">凭证行定义</div>
    <div class="btn-item-detail">
      <a v-hasPermi="['2022011115293689038']" href="javascript:;" @click="add()" class="btn-save"
        ><svg-icon
          :class="{ 'icon-img-admin': true }"
          style="font-size: 14px"
          icon-class="icon-add"
        />新增行</a
      >
      <a
        v-hasPermi="['2022011115300393693']"
        href="javascript:;"
        @click="handleDelete('eventData')"
        class="btn-save vxe-btn-delete"
        ><svg-icon
          :class="{ 'icon-img-admin': true }"
          style="font-size: 14px"
          icon-class="icon-white-delete"
        />删除行</a
      >
    </div>
    <div class="public-table">
      <vxe-grid
        border="outer"
        show-overflow
        resizable
        ref="voucherRows"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        column-min-width="120"
        :data="voucherRowData"
        :columns="linkColumnList"
        :toolbar="{}"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @checkbox-all="selectChangeEvent"
        @checkbox-change="selectChangeEvent"
      >
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'voucherRows',
    mounted() {
      // this.loadData()
    },
    props: {
      dataList: Object,
    },
    watch: {
      dataList(newValue) {
        this.voucherRowData = newValue.detailList;
      },
    },
    data() {
      return {
        voucherRowData: [],
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
          total: 0, //总共多少条
        },
        multipleSelection: [],
      };
    },
    computed: {
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '行号', visible: true, width: '80' },
          {
            field: 'entryCode',
            title: '凭证行编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'entryName',
            title: '行编名称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'entryDesc',
            title: '行编描述',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'natureSideCode',
            title: '借贷方向',
            editRender: {
              name: 'ElSelect',
              props: { clearable: true },
              options: [
                { value: "'C'", label: "'C'" },
                { value: "\D'", label: "'D'" },
              ],
            },
          },
          {
            field: 'pkCode',
            title: '记账码',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'sglCode',
            title: '特别总账标识',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'negativeFlag',
            title: '反记账标记',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'accountCode',
            title: '会计科目',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'accountDesc',
            title: '会计科目描述',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'profitCenterCode',
            title: '利润中心编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'profitCenterName',
            title: '利润中心名称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'costCenterCode',
            title: '成本中心编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'costCenterName',
            title: '成本中心名称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'enteredAmount',
            title: '录入金额',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'accountedAmount',
            title: '记账金额',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'currencyCode',
            title: '原币币种',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'companyCurrencyCode',
            title: '本位币币种',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'summary',
            title: '摘要',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'accountType',
            title: '会计类型',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'accountCondition',
            title: '会计条件',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'enableFlag',
            title: '启用',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'cashflowTransactionCode',
            title: '现金流量标识编码',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'cashflowTransactionName',
            title: '现金流量标识说明',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'taxCode',
            title: '税码',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'assignmentNo',
            title: '分配编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'dataKey',
            title: '数据关键字',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'exchangeRate',
            title: '汇率类型',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'bankAccountNum',
            title: '银行账号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'bankName',
            title: '银行名称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'sapBankCode',
            title: 'SAP 银行编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'partnerCode',
            title: '交易方编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'partnerZhName',
            title: '交易方名称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'supplierCode',
            title: '供应商编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'externalCustomerCode',
            title: '扩展客户编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'accountCondition',
            title: '供应商编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'maturityDate',
            title: '到期日期',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'loanNature',
            title: '贷款性质',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'batchNo',
            title: '批次号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'businessQuantity',
            title: '数量',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'businessUnit',
            title: '单位',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'orderNo',
            title: '订单编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'orderDetailNo',
            title: '订单行号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productCategory',
            title: '产品类别',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'externalContractNo',
            title: '外部合同号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'invoiceNo',
            title: '发票编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'baseQuantity',
            title: '基本数量',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'baseUnit',
            title: '基本单位',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'payCondition',
            title: '支付条件',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'payCondition',
            title: '支付方式',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'zzboeno',
            title: '外销/购发票物料号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'salesOrderNo',
            title: '销售订单编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'salesOrderItem',
            title: '销售订单行号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'contractNo',
            title: '合同编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'entityDataId',
            title: '单据数据ID',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'voucherDepartmentCode',
            title: '凭证部门编码',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'voucherDepartmentName',
            title: '凭证部门名称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'entryType',
            title: '录入类型',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'zzkunnrc',
            title: '外部客户编码',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'materialCode',
            title: '物料编号',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'plant',
            title: '工厂',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'amountWithoutTax',
            title: '不含税金额',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'downPaymentTrade',
            title: '预付订金交易',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    methods: {
      loadData() {
        let params = {
          id: this.$route.query.id,
          ...this.page,
        };
        this.$axios.post('/financial/tAeVoucherEntryTemplate/queryPage', params).then((res) => {
          this.voucherRowData = res.data.data.records;
          this.page.total = res.data.data.total;
        });
      },
      handleDelete() {
        const selectedList = this.$refs['voucherRows'].getSelectRecords(); // 或许选中数据
        let ids = [];
        selectedList.forEach((item) => {
          ids.push(item.id);
        });
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs['voucherRows'].removeSelecteds();
            this.$axios
              .post('/financial/tAeVoucherEntryTemplate/delVoucherEntryTemplate', { idList: ids })
              .then(() => {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('cooperation.message.deleteSuccess'),
                });
              });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      add() {
        this.$refs.voucherRows.commitProxy('insert_actived');
        // this.$refs.voucherRows.insertAt()
      },
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.loadData();
      },
      handlePagination(val) {
        this.page.pageNum = val;
        this.loadData();
      },
      selectChangeEvent(val) {
        this.multipleSelection = val.selection;
      },
      getData() {
        return this.$refs.voucherRows.getTableData().fullData;
      },
    },
  };
</script>

<style scoped lang="scss">
  .title {
    line-height: 40px;
    height: 40px;
  }
</style>
